import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const LetterIcon = createSvgIcon(
  <>
    <path
      d="M11.4295 3.25C7.25606 3.25752 5.07062 3.35998 3.67397 4.75663C2.16675 6.26385 2.16675 8.68969 2.16675 13.5414C2.16675 18.393 2.16675 20.8189 3.67397 22.3261C5.18119 23.8333 7.60703 23.8333 12.4587 23.8333C17.3104 23.8333 19.7362 23.8333 21.2435 22.3261C22.6401 20.9295 22.7426 18.744 22.7501 14.5706"
      {...strokeProps}
    />
    <path
      d="M11.977 14.0834C11.1933 4.18857 18.2026 1.38185 23.8123 2.34478C24.0388 5.62399 22.4343 6.8519 19.3787 7.41896C19.9687 8.03549 21.0113 8.81136 20.8988 9.78121C20.8188 10.4714 20.3501 10.81 19.4127 11.4872C17.3584 12.9714 14.9787 13.9074 11.977 14.0834Z"
      {...strokeProps}
    />
    <path d="M9.75 18.4167C11.9167 12.4584 14.0404 10.4394 16.25 8.66669" {...strokeProps} />
  </>,
  { displayName: 'LetterIcon', viewBox: '0 0 26 26' }
);
